// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import services, { CONTACT } from '../data/services';

function Footer() {
  return (
    <footer>
      <div className="footer-cta">
        <div className="footer-cta-inner">
          <h2>พร้อมดูแลน้องๆ ของคุณแล้ววันนี้</h2>
          <p>จองคิวหรือสอบถามได้เลย ทีมงานของเรายินดีให้คำปรึกษา</p>
          <div className="footer-cta-actions">
            <a
              href={CONTACT.lineUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-line-btn"
            >
              <span className="material-icons" aria-hidden="true">chat</span>
              จองคิวผ่าน LINE
            </a>
            <a href={CONTACT.phoneHref} className="footer-phone-btn">
              <span className="material-icons" aria-hidden="true">call</span>
              โทร {CONTACT.phone}
            </a>
          </div>
        </div>
      </div>

      <div className="footer-inner">
        <div className="footer-brand">
          <h3>Pet Direct Hospital</h3>
          <p>
            โรงพยาบาลสัตว์ครบวงจรย่านทองหล่อ
            ดูแลน้องๆสัตว์เลี้ยงของคุณเหมือนคนในครอบครัว
            ด้วยทีมสัตวแพทย์ผู้เชี่ยวชาญและอุปกรณ์ที่ทันสมัย
          </p>
        </div>
        <div className="footer-col">
          <h4>บริการ</h4>
          <ul>
            {services.map((service) => (
              <li key={service.slug}>
                <Link to={`/services/${service.slug}`}>{service.cardTitle}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="footer-col">
          <h4>ติดต่อเรา</h4>
          <ul>
            <li>
              <span className="material-icons" aria-hidden="true">place</span>
              {CONTACT.address}
            </li>
            <li>
              <span className="material-icons" aria-hidden="true">call</span>
              <a href={CONTACT.phoneHref}>{CONTACT.phone}</a>
            </li>
            <li>
              <span className="material-icons" aria-hidden="true">mail</span>
              <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            </li>
            <li>
              <span className="material-icons" aria-hidden="true">chat</span>
              LINE: {CONTACT.lineId}
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Pet Direct Hospital. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
